import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import VolunteerBankTable from "../../components/Volunteer/VolunteerBankTable";
import useProfile from "../../hooks/useProfile";

const VolunteerBankPage = () => {
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData.ugleve_name;
  return (
    <MainDiv>
      <VolunteerHeading>Approved Volunteer List</VolunteerHeading>
      <VolunteerBankTable user={user}></VolunteerBankTable>
      {/* <Profile /> */}
    </MainDiv>
  );
};

export default VolunteerBankPage;
